import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// State
import { isDiscountCashbackSystemSelector } from '../../../state/modules/city/selectors';

// Assets
import avatarPlaceholder from './assets/avatar-placeholder.svg';
import awardGold from './assets/award_gold.png';
import awardPlatinum from './assets/award_platinum.png';
import awardSilver from './assets/award_silver.png';
import coverGold from './assets/cover_gold.png';
import coverPlatinum from './assets/cover_platinum.png';
import coverSilver from './assets/cover_silver.png';

// Styles
import styles from './Avatar.styl';

const cx = classNames.bind(styles);

const awards = {
  silver: awardSilver,
  gold: awardGold,
  platinum: awardPlatinum,
};

const covers = {
  silver: coverSilver,
  gold: coverGold,
  platinum: coverPlatinum,
};

export default function Avatar(props) {
  const { className, status, avatar } = props;

  const isDiscountCashbackSystem = useSelector(isDiscountCashbackSystemSelector);

  return (
    <div
      className={cx('Avatar', className)}
      style={{ backgroundImage: `url(${covers[status] || covers.silver})` }}
    >
      <div
        className={cx('Avatar__person')}
        style={{ backgroundImage: `url(${avatar || avatarPlaceholder})` }}
      />
      {/*{isDiscountCashbackSystem && (*/}
      {/*  <img className={cx('Avatar__award')} src={awards[status] || awards.silver} alt="sailplay" />*/}
      {/*)}*/}
    </div>
  );
}

Avatar.defaultProps = {
  className: '',
  avatar: '',
  status: 'silver',
};

Avatar.propTypes = {
  className: PropTypes.string,
  avatar: PropTypes.string,
  status: PropTypes.string,
};
